import { Component, ViewChild, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ActionSheet, ActionSheetController, Config, ModalController,  PopoverController} from 'ionic-angular';
import { PbZonenData } from '../../../providers/pbzonen-data';
import { UserData } from '../../../providers/user-data';
import { MandantenData } from '../../../providers/mandanten-data';
import { PbcatrulesComponent } from "../../../../components/pbcatrules/pbcatrules";
import { ToastController } from 'ionic-angular';
import { CommonData } from '../../../providers/common-data';
import { CompletePPService } from '../../../providers/epautocomplete-service';
import { ParplatzData } from '../../../providers/pp-data';
import { TasksData } from '../../../providers/tasks-data';
import { PbKategorieSelection } from '../../pbkategorieselection/pbkategorieselection';
import { ParkbewilligungenData } from '../../parkbewilligungen-data';
import { CompleteZoneService } from '../../../providers/zoneautocomplete-service';
@Component({
  selector: 'page-tasks-edit',
  templateUrl: 'tasks-edit.html',
})
export class TasksEditPage {
  public task: any;
  public customertab = "taskinfo";  
  public readonly: boolean = false;
  
  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public userData: UserData
    , public mandantenData: MandantenData
    , public toastCtrl: ToastController
    , public common: CommonData
    , public zone: NgZone
    , public completePPService: CompletePPService
    , public taskData: TasksData
    , public popoverCtrl: PopoverController
    , public completeZoneService: CompleteZoneService
    ) {
    
    if(navParams.data.id>0){      
      this.prepareView(navParams.data.id);
             
    }
    else{
      //-- New pbzonen ------
    
      this.task = {done:0
                  
                  , mandate_mandid: this.userData.mandate_mandid
                  , attributes : {
                      edited:"created",
                      grundstuecke:[],
                      pbzonen:[],
                  }
                  
                };
    }

  }

  prepareView(id){
    this.taskData.view(id).then(res => {
      //console.log(res);
      this.prepareAttributes(res);

    });    

  }


  prepareAttributes(data){
    data.attributes = {edited:""};
    this.task = data;
  }

  changed($event){
    this.task.attributes.edited="changed";
  }
  ionViewDidLoad() {
    //console.log(this.mandantenData.data);
  }

  validateInputs(){
    /*
    if (!this.task.urlident || this.task.urlident == ""){
      return -1;
    }
    if (!this.task.mandate_mandid || this.task.mandate_mandid<=0){
      return -2;
    }
    */

    return 1;
 
  }



  changeActive(event){
    if(this.task.attributes.edited != "created"){
      this.task.attributes.edited = "changed";
    }
  }


  updateChanges(){

    switch(this.validateInputs()){
      case -1: this.common.showError('URL-Ident darf nicht leer sein.');
               return;
      case -2: this.common.showError('Mandat darf nicht leer sein.');
               return
               ;

    }
    if(this.task.attributes.edited =="changed"){
      this.taskData.update(this.task).then( (res:any) => {
        //console.log(res);
        if(!res.success){
          this.common.showError("Fehler beim Speichern");
          return;
        }
        else{
          this.prepareAttributes(res.data);   
          //this.updateBestellURL();          
          this.common.showError("Speichern erfolgreich");
      }
      });       
    }
    else if(this.task.attributes.edited =="created"){
      //console.log("create kat");
      //console.log(this.task);
      
      this.taskData.create(this.task).then(res => {
        //console.log(res);
        if(!res){
          this.common.showError("Fehler beim Speichern");
          return;
        }
        else{
          //this.updateBestellURL();
          this.prepareView(this.task.id);
          this.common.showError("Task erfolgreich gespeichert");


        }
      });      
    }
  }

  delete(){
    this.taskData.delete(this.task.id).then(res => {

      this.navCtrl.pop();
      //this.oSelectedKategorieRegeln = res;
    });    

  }

  discardChanges(){
    if(this.task.attributes.edited =="created"){
      this.navCtrl.pop();      
    }
    else{
      this.prepareView(this.task.id);
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/tasks/tasks-edit/tasks-edit.ts